"use client";

import React from "react";
import { MessageCircle, FileText, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ConsultoriaTecnicaImediata() {
  return <section id="consultoria-técnica-imediata" className="bg-secondary/10 text-foreground relative w-full overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 z-0 opacity-10 pointer-events-none overflow-hidden">
        <div className="absolute inset-0 w-[200%] animate-[wave-flow_20s_linear_infinite] flex">
          <svg className="h-full w-1/2 text-primary/20" viewBox="0 0 1440 800" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <path d="M0,400 C240,550 480,250 720,400 C960,550 1200,250 1440,400 V800 H0 V400 Z" fill="currentColor" className="text-primary/5" />
            <path d="M0,300 C240,450 480,150 720,300 C960,450 1200,150 1440,300" stroke="currentColor" strokeWidth="2" fill="none" className="opacity-20" />
            <path d="M0,500 C240,650 480,350 720,500 C960,650 1200,350 1440,500" stroke="currentColor" strokeWidth="2" fill="none" className="opacity-10" />
          </svg>
          <svg className="h-full w-1/2 text-primary/30" viewBox="0 0 1440 800" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <path d="M0,400 C240,550 480,250 720,400 C960,550 1200,250 1440,400 V800 H0 V400 Z" fill="currentColor" className="text-primary/10" />
            <path d="M0,300 C240,450 480,150 720,300 C960,450 1200,150 1440,300" stroke="currentColor" strokeWidth="2" fill="none" className="opacity-50" />
            <path d="M0,500 C240,650 480,350 720,500 C960,650 1200,350 1440,500" stroke="currentColor" strokeWidth="2" fill="none" className="opacity-30" />
          </svg>
        </div>
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 text-center">
        <div className="mx-auto max-w-4xl">
          <h2 className="mb-6 text-3xl font-bold tracking-tight text-foreground sm:text-4xl md:text-5xl lg:text-6xl">
            Precisa de uma solução térmica de alta precisão?
          </h2>
          
          <p className="mx-auto mb-10 max-w-2xl text-lg text-muted-foreground md:text-xl">
            Fale agora com nosso corpo técnico e agende um diagnóstico especializado.
          </p>

          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            {}
            <Link to="/ContactPage">
              <Button variant="default" size="lg" className="h-14 min-w-[240px] text-lg font-semibold transition-transform hover:scale-105">
                <FileText className="mr-2 size-5" />
                Solicitar Proposta
              </Button>
            </Link>

            {}
            <Link to="https://wa.me/5511999999999" newTab>
              <Button variant="outline" size="lg" className="h-14 min-w-[240px] border-primary/30 bg-background text-lg font-semibold text-foreground hover:bg-secondary/20">
                <MessageCircle className="mr-2 size-5" />
                WhatsApp Engenharia
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {}
      <style jsx global>{`
        @keyframes wave-flow {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </section>;
}